import type { UseFormProps } from 'react-hook-form';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';

export type FormRequest = {
  productPlanId: string;
  inquiry: string;
  softwareId: string;
  requester: string;
};

export const useItAdminForm = () => {
  const validationItAdminSchema = Yup.object().shape({
    productPlanId: Yup.string().required('Product_Use_Request_10'),
    inquiry: Yup.string().optional(),
    requester: Yup.string().optional(),
  });
  const ItAdminFormOptions: UseFormProps<FormRequest> = {
    resolver: yupResolver(validationItAdminSchema),
    mode: 'onChange',
    shouldFocusError: true,
  };
  return useForm<FormRequest>(ItAdminFormOptions);
};
